import { useState } from 'react';
import { login, resetPassword } from '../services/adminService';

export const LoginPage = ({ onLogin }) => {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [resetting, setResetting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setMessage('');

    try {
      const user = await login(form.username, form.password);
      onLogin(user);
    } catch (loginError) {
      setError(loginError.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleResetPassword = async () => {
    setResetting(true);
    setError('');
    setMessage('');

    try {
      await resetPassword(form.username);
      setMessage('If an account exists for that email, a password reset email will be sent.');
    } catch (resetError) {
      setError('Password reset is temporarily unavailable. Please try again later.');
    } finally {
      setResetting(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="container">
        <div className="row align-content-center">
          <form className="signIn col-12 col-sm-7 col-md-6 col-lg-4 col-xl-3 mx-auto text-center px-4 py-5" onSubmit={handleSubmit}>
            <img className="mb-5 w-100" src="./logo.png" alt="Photociancio" />
            <br />
            <input
              id="username"
              name="username"
              autoComplete="username"
              className="form-control text-center mb-1"
              placeholder="Username"
              type="email"
              required
              value={form.username}
              onChange={(event) => setForm((current) => ({ ...current, username: event.target.value }))}
            />
            <input
              id="password"
              name="password"
              autoComplete="current-password"
              className="form-control text-center mb-4"
              placeholder="Password"
              type="password"
              required
              value={form.password}
              onChange={(event) => setForm((current) => ({ ...current, password: event.target.value }))}
            />
            {error && <p className="text-danger bg-light rounded p-2">{error}</p>}
            {message && <p className="text-success bg-light rounded p-2">{message}</p>}
            <button type="submit" className="btn btn-light w-100 mb-2" disabled={submitting || resetting}>
              {submitting ? 'Logging in...' : 'Login'}
            </button>
            <button
              type="button"
              className="btn bg-beige w-100"
              disabled={!form.username || submitting || resetting}
              onClick={handleResetPassword}
            >
              {resetting ? 'Sending Reset...' : 'Reset Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

